// Financial Reporting suite — the four stat tiles (five-second rule):
// due this month / overdue (error) / completed YTD / on-time rate.

import { cn } from "@/design-system/lib/utils";
import type { ReportingStatsDto } from "@/api/portfolioAdmin/financialReportingApi";

export function ReportingStatTiles({ stats }: { stats: ReportingStatsDto }) {
  const tiles: { key: string; label: string; value: string; tone: string }[] = [
    {
      key: "due-this-month",
      label: "Due this month",
      value: String(stats.dueThisMonth),
      tone:
        stats.dueThisMonth > 0
          ? "border-status-warning text-status-warning"
          : "border-border-light text-gray-mid",
    },
    {
      key: "overdue",
      label: "Overdue",
      value: String(stats.overdue),
      tone:
        stats.overdue > 0
          ? "border-status-error text-status-error"
          : "border-border-light text-gray-mid",
    },
    {
      key: "completed-ytd",
      label: "Completed YTD",
      value: String(stats.completedYtd),
      tone: "border-status-success text-status-success",
    },
    {
      key: "on-time-rate",
      label: "On-time rate",
      value: stats.onTimeRatePct === null ? "—" : `${stats.onTimeRatePct}%`,
      tone:
        stats.onTimeRatePct !== null && stats.onTimeRatePct < 100
          ? "border-status-warning text-status-warning"
          : "border-status-success text-status-success",
    },
  ];

  return (
    <div
      className="grid grid-cols-2 md:grid-cols-4 gap-space-2"
      data-testid="reporting-stat-tiles"
    >
      {tiles.map((t) => (
        <div
          key={t.key}
          className={cn(
            "rounded-md border-2 bg-white-pure px-space-3 py-space-2",
            t.tone,
          )}
          data-testid={`reporting-tile-${t.key}`}
        >
          <div className="text-caption uppercase tracking-wide">{t.label}</div>
          <div className="text-h3 font-bold tabular-nums">{t.value}</div>
        </div>
      ))}
    </div>
  );
}
